import { render, staticRenderFns } from "./InfoContentOther.pug?vue&type=template&id=48163996&scoped=true&lang=pug&"
import script from "./InfoContentOther.vue?vue&type=script&lang=js&"
export * from "./InfoContentOther.vue?vue&type=script&lang=js&"
import style0 from "./InfoContentOther.scss?vue&type=style&index=0&id=48163996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48163996",
  null
  
)

export default component.exports